import { TextareaAutosize } from '@mui/material';
import { Button } from './ui/button';

interface PersonalizedTextareaWithResetProps {
  id?: string;
  value: string | undefined;
  onChange: (value: string) => void;
  placeholder?: string;
  disabled?: boolean;
  minRows?: number;
  maxRows?: number;
  testId?: string;
}

export function PersonalizedTextareaWithReset({
  id,
  value,
  onChange,
  placeholder = 'Add a personalized message',
  disabled = false,
  minRows = 3,
  maxRows = 6,
  testId,
}: PersonalizedTextareaWithResetProps) {
  const hasUserTyped = value !== undefined && value !== '';

  const handleResetMessage = () => {
    onChange('');
  };

  const resetButtonProps = {
    variant: 'outline' as const,
    size: 'sm' as const,
    onClick: handleResetMessage,
    className:
      'absolute bottom-2 right-2 h-7 border-gray-300 px-2 text-xs text-gray-500 hover:border-primary hover:bg-gray-100 hover:text-primary',
  };

  return (
    <div className="relative">
      <TextareaAutosize
        id={id}
        data-testid={testId ?? undefined}
        placeholder={placeholder}
        className="border-primary-300 focus:ring-primary block w-full rounded-md border bg-white px-2 pb-8 pt-1.5 text-sm leading-6 text-gray-900 shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-offset-1"
        minRows={minRows}
        maxRows={maxRows}
        value={value}
        onChange={e => onChange(e.target.value)}
        disabled={disabled}
      />
      {hasUserTyped && (
        <Button
          data-testid={testId ? `${testId}-reset-button` : undefined}
          {...resetButtonProps}
        >
          Reset
        </Button>
      )}
    </div>
  );
}
